import { language } from './config'
export const texts =
  language === 'ua'
    ? {
        //ukrainian
        title_1: 'Найкоротша історія',
        title_2: 'російсько-української війни',
        introduction:
          'Війна у центрі Європи в 21-му сторіччі. Цю словесну конструкцію в останнє десятиріччя можна було часто почути від людей, яким бракувало слів, аби описати свій подив, жах, обурення подіями в Україні. Здавалося, що класична війна, де артилерійський снаряд чи ракета «Граду» руйнує будинок, валить диспетчерську вежу аеропорту, де з’являється поняття «ветерани» – це не про новітню історію Європи. Але реальність була саме такою: у 2014 році в українських містах почалася війна, і цією війною керувала Росія. Попри те, що після 2014 року західні і українські OSINT-спільноти, аналітичні центри і журналісти здійснили десятки розслідувань російської присутності у Криму та на Донбасі, багато медіа та інституцій Заходу уникали називати Росію стороною війни. Остаточне розуміння цього прийшло лише після повномасштабного вторгнення. У цьому проєкті Радіо Свобода та редакція Донбас Реалії зібрали максимально показову – та водночас коротку – хроніку останніх 10 воєнних років в Україні. Тут ми згадали найважливіше для того, аби зрозуміти, як саме Кремль почав, розпалив, довів бойові дії до масштабів, яких світ не бачив із часів Другої світової, та веде їх досі.',
        share: 'Подiлитись',
        about_1: 'ПРО ПРОЄКТ',
        about_2:
          'У підготовці проєкту використані матеріали: журналістів Радіо Свобода, DeepState, Atlantic Council, InformNapalm, Bellingcat, Conflict Intelligence Team, українських та західних медіа, свідчення учасників російсько-української війни, жителів окупованих територій, учасників українського спротиву 2014 року у Донецьку, Луганську та Криму.',
        about_3: 'ПРО РАДІО СВОБОДА',
        about_4:
          'Радіо Свобода – це служба Радіо Вільна Європа/Радіо Свобода (РВЄ/РС), яка є незалежною медіакорпорацією, котру фінансує Конгрес США через гранти, які надає через Американське агентство глобальних медіа (U.S. Agency for Global Media, USAGM). РВЄ/РС керується законодавством США для надання точного, об’єктивного та професійного журналістського продукту для своєї аудиторії. Американським урядовцям, включно з керівництвом USAGM, заборонено втручатися в журналістську подачу інформації РВЄ/РС.',
        about_5:
          'Донбас Реалії – проєкт української редакції Радіо Свобода, що інформує про актуальні теми жителів східних областей України, включно з окупованими частинами, а також розповідає про події на Донбасі для національної та міжнародної аудиторії.',
        authors_1: 'НАД ПРОЄКТОМ ПРАЦЮВАЛИ:',
        authors_2: 'Автори проекту:',
        authors_3: 'Тетяна Якубович, Роман Пагулич, Олена Механік',
        authors_4: 'Редактори:',
        authors_5: 'Денис Тимошенко, Світлана Кузьменко',
        authors_6: 'Продюсер:',
        authors_7: 'Владислав Яцків',
        authors_8: 'Разробка та дизайн:',
        authors_9: 'RFE/RL’s Pangea Digital Team',
        follow_1: 'ДОЛУЧАЙСЯ ДО РАДІО СВОБОДА',
        follow_2: 'ПРИЄДНУЙСЯ ДО ДОНБАС РЕАЛІЇ',
        copyright_1: '© Радіо Свобода, ',
        copyright_2: ' | Усі права застережено.',
        menu_1: 'Крим. Анексія',
        menu_2: 'лютий-березень 2014',
        menu_3: 'Донбас. Початок вторгнення',
        menu_4: 'березень-травень 2014',
        menu_5: 'Поява регулярної армії РФ',
        menu_6: 'травень 2014-січень 2022',
        menu_7: 'Бліцкриг',
        menu_8: 'лютий-березень 2022',
        menu_9: 'Повзучий наступ Росії',
        menu_10: 'весна-літо 2022',
        menu_11: 'Осінній наступ України',
        menu_12: 'осінь 2022',
        menu_13: 'Бахмут. Наступ Росії',
        menu_14: 'зима 2022-весна 2023',
        menu_15: 'Літній наступ України',
        menu_16: 'літо-осінь 2023',
        menu_17: 'Авдіївка. Загострення по всьому фронту',
        menu_18: 'осінь 2023-дотепер',
        read_more: 'читати більше',
        read_less: 'згорнути',
        watchOnYT: <>Дивитися на&nbsp;YouTube</>,
      }
    : {
        //russian
        title_1: 'Самая короткая история',
        title_2: ' российско-украинской войны',
        introduction:
          'Война в центре Европы в 21 веке. Эту словесную конструкцию в последнее десятилетие можно было часто услышать от людей, которым не хватало слов, чтобы описать свое удивление, ужас, возмущение событиями в Украине. Казалось, что классическая война, где артиллерийский снаряд или ракета «Града» разрушает дом, рушит диспетчерскую башню аэропорта, где появляется понятие «ветераны» – это не новейшая история Европы. Но реальность была именно такой: в 2014 году в украинских городах началась война и этой войной руководила Россия. Несмотря на то, что после 2014 года западные и украинские OSINT-сообщества, аналитические центры и журналисты провели десятки расследований российского присутствия в Крыму и на Донбассе, многие медиа и институты Запада избегали называть Россию стороной войны. Окончательное понимание этого пришло только после полномасштабного вторжения. В этом проекте Радіо Свобода и редакция Донбасс Реалии собрали максимально показательную – и одновременно краткую – хронику последних 10 военных лет в Украине. Здесь мы вспомнили самое важное для того, чтобы понять, как именно Кремль начал, разжег, довел боевые действия до масштабов, которых не было со времен Второй мировой, и ведет их до сих пор.',
        share: 'Поделись',
        about_1: 'ПРО ПРОЕКТ',
        about_2:
          'В подготовке проекта использованы материалы: журналистов Радіо Свобода, DeepState, Atlantic Council, InformNapalm, Bellingcat, Conflict Intelligence Team, украинских и западных медиа, свидетельства участников российско-украинской войны, жителей оккупированных территорий, участников украинского сопротивления 2014 года в Донецке, Луганске и Крыму.',
        about_3: 'ПРО Радіо Свобода',
        about_4:
          'Радіо Свобода – это служба Radio Free Europe/Radio Liberty (RFE/RL), которая является независимой медиакорпорацией, финансируемой Конгрессом США через гранты, предоставляемые через Американское агентство глобальных медиа (U.S. Agency for Global Media, USAGM). RFE/RL руководствуется законодательством США для предоставления точного, объективного и профессионального журналистского продукта для своей аудитории. Американским правительственным чиновникам, включая руководство USAGM, запрещено вмешиваться в журналистскую подачу информации RFE/RL.',
        about_5:
          'Донбасс Реалии – проект украинской редакции Радіо Свобода, информирующий об актуальных темах жителей восточных областей Украины, включая оккупированные части, а также рассказывает о событиях на Донбассе для национальной и международной аудитории.',
        authors_1: 'НАД ПРОЕКТОМ РАБОТАЛИ',
        authors_2: 'Авторы проекта:',
        authors_3: 'Татьяна Якубович, Роман Пагулич, Елена Механик.',
        authors_4: 'Редакторы:',
        authors_5: 'Денис Тимошенко, Светлана Кузьменко',
        authors_6: 'Продюсер:',
        authors_7: 'Владислав Яцкив',
        authors_8: 'Разработка и дизайн:',
        authors_9: 'RFE/RL’s Pangea Digital Team',
        follow_1: 'ПРИСОЕДИНЯЙСЯ К Радіо Свобода',
        follow_2: 'ПРИСОЕДИНЯЙСЯ К Донбасс РЕАЛИИ',
        copyright_1: '© Радіо Свобода, ',
        copyright_2: ' | Все права защищены.',
        menu_1: 'Крым. Аннексия',
        menu_2: 'февраль-март 2014',
        menu_3: 'Донбасс. Начало вторжения',
        menu_4: 'март-май 2014',
        menu_5: 'Появление регулярной армии РФ',
        menu_6: 'май 2014-январь 2022',
        menu_7: 'Блицкриг',
        menu_8: 'февраль-март 2022',
        menu_9: 'Ползучее наступление России',
        menu_10: 'весна-лето 2022',
        menu_11: 'Осеннее наступление Украины',
        menu_12: 'осень 2022',
        menu_13: 'Бахмут. Наступление России',
        menu_14: 'зима 2022-весна 2023',
        menu_15: 'Летнее наступление Украины',
        menu_16: 'лето–осень 2023',
        menu_17: 'Авдеевка. Обострение по всему фронту',
        menu_18: 'осень 2023 года – по сегодняшний день',
        read_more: 'читать больше',
        read_less: 'свернуть',
        watchOnYT: <>Смотреть на&nbsp;YouTube</>,
      }
